import './bootstrap.js';

import '@fontsource-variable/inter';
import '@fontsource-variable/manrope';
import '../styles/app.css';
import 'tippy.js/dist/tippy.css';

import { createInertiaApp } from '@inertiajs/vue3';
import { createPinia } from 'pinia';
import { ZiggyVue } from 'ziggy-js';
import * as Sentry from '@sentry/vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import AppLayout from '@/layouts/AppLayout.vue';
import dayjs from 'dayjs';
import 'dayjs/locale/nl.js';
import { initializeFlashToast } from '@/utils/flash';
import { initializeHttpErrorHandling } from '@/utils/http';

dayjs.locale('nl');

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Maat Stalling';
const pinia = createPinia();

initializeHttpErrorHandling();
initializeFlashToast();

void createInertiaApp({
    title: (title) => (title ? `${ title } — ${ appName }` : `${ appName }`),
    pages: './views',
    layout: (name) => {
        if (name.startsWith('auth/')) {
            return AuthLayout;
        }

        if (name.startsWith('errors/')) {
            return null;
        }

        return AppLayout;
    },
    withApp(app) {
        Sentry.init({
            app,
            environment: import.meta.env.VITE_APP_ENV,
            dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
            sendDefaultPii: true,
            integrations: [
                Sentry.browserTracingIntegration(),
            ],
            tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
            replaysSessionSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? 0),
            replaysOnErrorSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? 1),
        });

        app
            .use(ZiggyVue)
            .use(pinia);
    },
    progress: {
        color: '#4B5563',
        includeCSS: true,
        showSpinner: true,
    },
});
